import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { useContext, useMemo } from 'react';
import genericModules from './mocks/genericModules.json';

const useGenericModules = () => {
  const { t } = useContext(ConfigContext);
  const isLoading = false;
  const data = genericModules;

  const modulesOptions = useMemo(
    () => (data?.data || []).map(({ id, slug }) => ({ value: id, label: t(slug), slug })),
    [data?.data, t]
  );

  const mappedGenericModules = useMemo(
    () => modulesOptions.reduce((prev, module) => ({ ...prev, [module.value]: module }), {}),
    [modulesOptions]
  );

  return { isLoading, modulesOptions, mappedGenericModules };
};

export default useGenericModules;
